import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, LOCALE_ID } from '@angular/core';
import { AuthInterceptor } from 'angular-auth-oidc-client';

import { GlobalErrorHandlerService } from './global-error-handler.service';
import { SessionidHttpInterceptorService } from './sessionid-http-interceptor.service';

export const ALL_HTTP_INTERCEPTORS_AND_HANDLERS = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: SessionidHttpInterceptorService,
        multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: GlobalErrorHandlerService,
        multi: true,
    },
    {
        provide: ErrorHandler,
        useClass: GlobalErrorHandlerService,
    },
    {
        provide: LOCALE_ID,
        useValue: 'de-CH',
    },
];
